module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v("Konfiguracija: " + _vm._s(_vm.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Za fakturu")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("priceByUser")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.priceByUser),
      expression: "model.priceByUser"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "priceByUser"
    },
    domProps: {
      "value": (_vm.model.priceByUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "priceByUser", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("discount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.discount),
      expression: "model.discount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "discount"
    },
    domProps: {
      "value": (_vm.model.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "discount", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("currentBalance")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.currentBalance),
      expression: "model.currentBalance"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "currentBalance"
    },
    domProps: {
      "value": (_vm.model.currentBalance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "currentBalance", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("partnerCompanyInfoInvoice")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.partnerCompanyInfoInvoice),
      expression: "model.partnerCompanyInfoInvoice"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "partnerCompanyInfoInvoice"
    },
    domProps: {
      "value": (_vm.model.partnerCompanyInfoInvoice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "partnerCompanyInfoInvoice", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("priceList")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.priceList),
      expression: "model.priceList"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "priceList"
    },
    domProps: {
      "value": (_vm.model.priceList)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "priceList", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("fixedPrice")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.fixedPrice),
      expression: "model.fixedPrice"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "fixedPrice"
    },
    domProps: {
      "value": (_vm.model.fixedPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "fixedPrice", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useForInvoiceOnlyActiveMembers")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useForInvoiceOnlyActiveMembers),
      expression: "model.useForInvoiceOnlyActiveMembers"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "discount"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useForInvoiceOnlyActiveMembers) ? _vm._i(_vm.model.useForInvoiceOnlyActiveMembers, null) > -1 : (_vm.model.useForInvoiceOnlyActiveMembers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useForInvoiceOnlyActiveMembers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useForInvoiceOnlyActiveMembers", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useForInvoiceOnlyActiveMembers", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useForInvoiceOnlyActiveMembers", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("additionalInvoices")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.additionalInvoices),
      expression: "model.additionalInvoices"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "additionalInvoices"
    },
    domProps: {
      "value": (_vm.model.additionalInvoices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "additionalInvoices", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("companyName")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyName),
      expression: "model.companyName"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "companyName",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "companyName", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("companyAddress")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyAddress),
      expression: "model.companyAddress"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "companyAddress",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.companyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "companyAddress", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("companyPhone")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyPhone),
      expression: "model.companyPhone"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "companyPhone",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.companyPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "companyPhone", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("companyBusyProgress")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyBusyProgress),
      expression: "model.companyBusyProgress"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "companyBusyProgress",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.companyBusyProgress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "companyBusyProgress", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("tabs")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tabs),
      expression: "model.tabs"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "tabs",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.tabs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tabs", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showNotificationOnHome")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showNotificationOnHome),
      expression: "model.showNotificationOnHome"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showNotificationOnHome) ? _vm._i(_vm.model.showNotificationOnHome, null) > -1 : (_vm.model.showNotificationOnHome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showNotificationOnHome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showNotificationOnHome", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showNotificationOnHome", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showNotificationOnHome", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("canAddUserWithTerm")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canAddUserWithTerm),
      expression: "model.canAddUserWithTerm"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.canAddUserWithTerm) ? _vm._i(_vm.model.canAddUserWithTerm, null) > -1 : (_vm.model.canAddUserWithTerm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.canAddUserWithTerm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "canAddUserWithTerm", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "canAddUserWithTerm", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "canAddUserWithTerm", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showConcreteValueForPayment")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showConcreteValueForPayment),
      expression: "model.showConcreteValueForPayment"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showConcreteValueForPayment) ? _vm._i(_vm.model.showConcreteValueForPayment, null) > -1 : (_vm.model.showConcreteValueForPayment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showConcreteValueForPayment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showConcreteValueForPayment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showConcreteValueForPayment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showConcreteValueForPayment", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("userVisibleDays")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userVisibleDays),
      expression: "model.userVisibleDays"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "userVisibleDays",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.userVisibleDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "userVisibleDays", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("adminVisibleDays")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.adminVisibleDays),
      expression: "model.adminVisibleDays"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "adminVisibleDays",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.adminVisibleDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "adminVisibleDays", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("hasTerms")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.hasTerms),
      expression: "model.hasTerms"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.hasTerms) ? _vm._i(_vm.model.hasTerms, null) > -1 : (_vm.model.hasTerms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.hasTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "hasTerms", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "hasTerms", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "hasTerms", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("shouldAskToDownloadApps")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shouldAskToDownloadApps),
      expression: "model.shouldAskToDownloadApps"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.shouldAskToDownloadApps) ? _vm._i(_vm.model.shouldAskToDownloadApps, null) > -1 : (_vm.model.shouldAskToDownloadApps)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.shouldAskToDownloadApps,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "shouldAskToDownloadApps", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "shouldAskToDownloadApps", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "shouldAskToDownloadApps", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("googlePlay "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showGooglePlay()
      }
    }
  }, [_vm._v("Prikazi QR kod")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.googlePlay),
      expression: "model.googlePlay"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "googlePlay",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.googlePlay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "googlePlay", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("googlePlayByLocation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.googlePlayByLocation),
      expression: "model.googlePlayByLocation"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "googlePlayByLocation",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.googlePlayByLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "googlePlayByLocation", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("appStore "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showAppStore()
      }
    }
  }, [_vm._v("Prikazi QR kod")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.appStore),
      expression: "model.appStore"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "appStore",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.appStore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "appStore", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("appStoreByLocation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.appStoreByLocation),
      expression: "model.appStoreByLocation"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "appStoreByLocation",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.appStoreByLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "appStoreByLocation", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("huaweiUpdateLink "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showHuaweiStore()
      }
    }
  }, [_vm._v("Prikazi QR kod")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.huaweiUpdateLink),
      expression: "model.huaweiUpdateLink"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "huaweiUpdateLink",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.huaweiUpdateLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "huaweiUpdateLink", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("huaweiUpdateLinkByLocation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.huaweiUpdateLinkByLocation),
      expression: "model.huaweiUpdateLinkByLocation"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "huaweiUpdateLinkByLocation",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.huaweiUpdateLinkByLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "huaweiUpdateLinkByLocation", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("canExtendPayment")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canExtendPayment),
      expression: "model.canExtendPayment"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.canExtendPayment) ? _vm._i(_vm.model.canExtendPayment, null) > -1 : (_vm.model.canExtendPayment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.canExtendPayment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "canExtendPayment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "canExtendPayment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "canExtendPayment", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("canAddTrainingType")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canAddTrainingType),
      expression: "model.canAddTrainingType"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hasTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.canAddTrainingType) ? _vm._i(_vm.model.canAddTrainingType, null) > -1 : (_vm.model.canAddTrainingType)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.canAddTrainingType,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "canAddTrainingType", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "canAddTrainingType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "canAddTrainingType", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("customCategory for user ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.customCategory),
      expression: "model.customCategory"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "Custom category",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.customCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "customCategory", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("customCategories for user ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.customCategories),
      expression: "model.customCategories"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "Custom categories",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.customCategories)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "customCategories", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("trainingTypesCanShowLoyalty")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(30), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingTypesCanShowLoyalty),
      expression: "model.trainingTypesCanShowLoyalty"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "trainingTypesCanShowLoyalty",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.trainingTypesCanShowLoyalty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "trainingTypesCanShowLoyalty", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("userCount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(31), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userCount),
      expression: "model.userCount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "userCount",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.userCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "userCount", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("minutesToCancelTraining")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(32), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.minutesToCancelTraining),
      expression: "model.minutesToCancelTraining"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "minutesToCancelTraining",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.minutesToCancelTraining)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "minutesToCancelTraining", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("minutesToReserveTraining")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(33), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.minutesToReserveTraining),
      expression: "model.minutesToReserveTraining"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "minutesToReserveTraining",
      "name": "minutesToReserveTraining"
    },
    domProps: {
      "value": (_vm.model.minutesToReserveTraining)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "minutesToReserveTraining", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("companyMail")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(34), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.companyMail),
      expression: "model.companyMail"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "companyMail",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.companyMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "companyMail", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("fromMail")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(35), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.fromMail),
      expression: "model.fromMail"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "fromMail",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.fromMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "fromMail", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("limits")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(36), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.limits),
      expression: "model.limits"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "limits",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.limits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "limits", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("additionalKits")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(37), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.additionalKits),
      expression: "model.additionalKits"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "additionalKits",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.additionalKits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "additionalKits", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("trainingTypes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(38), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingTypes),
      expression: "model.trainingTypes"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "trainingTypes",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.trainingTypes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "trainingTypes", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("reserveTrainingLimits")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(39), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.reserveTrainingLimits),
      expression: "model.reserveTrainingLimits"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "reserveTrainingLimits",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.reserveTrainingLimits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "reserveTrainingLimits", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("maxHourToVisibleSlot")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(40), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxHourToVisibleSlot),
      expression: "model.maxHourToVisibleSlot"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "maxHourToVisibleSlot",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.maxHourToVisibleSlot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxHourToVisibleSlot", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("maxDiffToVisibleSlot")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(41), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxDiffToVisibleSlot),
      expression: "model.maxDiffToVisibleSlot"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "maxDiffToVisibleSlot",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.maxDiffToVisibleSlot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxDiffToVisibleSlot", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("maxReserveTrainingAsDebtor")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(42), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxReserveTrainingAsDebtor),
      expression: "model.maxReserveTrainingAsDebtor"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "maxReserveTrainingAsDebtor",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.maxReserveTrainingAsDebtor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxReserveTrainingAsDebtor", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("sendMailKey")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(43), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sendMailKey),
      expression: "model.sendMailKey"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "sendMailKey",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.sendMailKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "sendMailKey", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Terms and conditions url")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(44), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.termsAndCondUrl),
      expression: "model.termsAndCondUrl"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "termsAndCondUrl",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.termsAndCondUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "termsAndCondUrl", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enablePartnersForRegister")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(45), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enablePartnersForRegister),
      expression: "model.enablePartnersForRegister"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enablePartnersForRegister"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enablePartnersForRegister) ? _vm._i(_vm.model.enablePartnersForRegister, null) > -1 : (_vm.model.enablePartnersForRegister)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enablePartnersForRegister,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enablePartnersForRegister", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enablePartnersForRegister", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enablePartnersForRegister", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableVegaReport")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(46), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableVegaReport),
      expression: "model.enableVegaReport"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableVegaReport"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableVegaReport) ? _vm._i(_vm.model.enableVegaReport, null) > -1 : (_vm.model.enableVegaReport)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableVegaReport,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableVegaReport", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableVegaReport", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableVegaReport", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("allowToChangeSlotWithUsers")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(47), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.allowToChangeSlotWithUsers),
      expression: "model.allowToChangeSlotWithUsers"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "allowToChangeSlotWithUsers"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.allowToChangeSlotWithUsers) ? _vm._i(_vm.model.allowToChangeSlotWithUsers, null) > -1 : (_vm.model.allowToChangeSlotWithUsers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.allowToChangeSlotWithUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "allowToChangeSlotWithUsers", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "allowToChangeSlotWithUsers", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "allowToChangeSlotWithUsers", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useQrCode")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(48), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useQrCode),
      expression: "model.useQrCode"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useQrCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useQrCode) ? _vm._i(_vm.model.useQrCode, null) > -1 : (_vm.model.useQrCode)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useQrCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useQrCode", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useQrCode", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useQrCode", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showPaymentInvoiceLink")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(49), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showPaymentInvoiceLink),
      expression: "model.showPaymentInvoiceLink"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useQrCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showPaymentInvoiceLink) ? _vm._i(_vm.model.showPaymentInvoiceLink, null) > -1 : (_vm.model.showPaymentInvoiceLink)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showPaymentInvoiceLink,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showPaymentInvoiceLink", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showPaymentInvoiceLink", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showPaymentInvoiceLink", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useProfilePictures")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(50), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useProfilePictures),
      expression: "model.useProfilePictures"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useQrCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useProfilePictures) ? _vm._i(_vm.model.useProfilePictures, null) > -1 : (_vm.model.useProfilePictures)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useProfilePictures,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useProfilePictures", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useProfilePictures", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useProfilePictures", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showRestTrainings")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(51), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showRestTrainings),
      expression: "model.showRestTrainings"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useQrCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showRestTrainings) ? _vm._i(_vm.model.showRestTrainings, null) > -1 : (_vm.model.showRestTrainings)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showRestTrainings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showRestTrainings", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showRestTrainings", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showRestTrainings", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("colorsForTrainingTypes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(52), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.colorsForTrainingTypes),
      expression: "model.colorsForTrainingTypes"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "colorsForTrainingTypes",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.colorsForTrainingTypes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "colorsForTrainingTypes", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("regVersionToShow")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(53), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.regVersionToShow),
      expression: "model.regVersionToShow"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "regVersionToShow",
      "name": "usercount"
    },
    domProps: {
      "value": (_vm.model.regVersionToShow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "regVersionToShow", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showRegAlways")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(54), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showRegAlways),
      expression: "model.showRegAlways"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useQrCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showRegAlways) ? _vm._i(_vm.model.showRegAlways, null) > -1 : (_vm.model.showRegAlways)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showRegAlways,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showRegAlways", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showRegAlways", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showRegAlways", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("qrSymbology ('set qrcode' ako kompanija koristi qr code)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(55), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.qrSymbology),
      expression: "model.qrSymbology"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "termsAndCondUrl",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.qrSymbology)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "qrSymbology", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("allowToReserveTrainingAsDebtor")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(56), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.allowToReserveTrainingAsDebtor),
      expression: "model.allowToReserveTrainingAsDebtor"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "allowToReserveTrainingAsDebtor"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.allowToReserveTrainingAsDebtor) ? _vm._i(_vm.model.allowToReserveTrainingAsDebtor, null) > -1 : (_vm.model.allowToReserveTrainingAsDebtor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.allowToReserveTrainingAsDebtor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "allowToReserveTrainingAsDebtor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "allowToReserveTrainingAsDebtor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "allowToReserveTrainingAsDebtor", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showTrainerOnSlotToUser")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(57), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showTrainerOnSlotToUser),
      expression: "model.showTrainerOnSlotToUser"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "showTrainerOnSlotToUser"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showTrainerOnSlotToUser) ? _vm._i(_vm.model.showTrainerOnSlotToUser, null) > -1 : (_vm.model.showTrainerOnSlotToUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showTrainerOnSlotToUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showTrainerOnSlotToUser", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showTrainerOnSlotToUser", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showTrainerOnSlotToUser", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("loyaltyPrograms (loyalty program, primer loyalty_6;loyalty_12...)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(58), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.loyaltyPrograms),
      expression: "model.loyaltyPrograms"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "loyaltyPrograms",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.loyaltyPrograms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "loyaltyPrograms", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("onlyMainAdminCanDeletePayment")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(59), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.onlyMainAdminCanDeletePayment),
      expression: "model.onlyMainAdminCanDeletePayment"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "onlyMainAdminCanDeletePayment"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.onlyMainAdminCanDeletePayment) ? _vm._i(_vm.model.onlyMainAdminCanDeletePayment, null) > -1 : (_vm.model.onlyMainAdminCanDeletePayment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.onlyMainAdminCanDeletePayment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "onlyMainAdminCanDeletePayment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "onlyMainAdminCanDeletePayment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "onlyMainAdminCanDeletePayment", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("howLongDayBeforeExpireUserCanExtendPayment")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(60), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.howLongDayBeforeExpireUserCanExtendPayment),
      expression: "model.howLongDayBeforeExpireUserCanExtendPayment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "howLongDayBeforeExpireUserCanExtendPayment"
    },
    domProps: {
      "value": (_vm.model.howLongDayBeforeExpireUserCanExtendPayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "howLongDayBeforeExpireUserCanExtendPayment", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableBuyMembership")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(61), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableBuyMembership),
      expression: "model.enableBuyMembership"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableBuyMembership"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableBuyMembership) ? _vm._i(_vm.model.enableBuyMembership, null) > -1 : (_vm.model.enableBuyMembership)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableBuyMembership,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableBuyMembership", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableBuyMembership", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableBuyMembership", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableBuyMembershipByLocation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(62), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableBuyMembershipByLocation),
      expression: "model.enableBuyMembershipByLocation"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "enableBuyMembershipByLocation"
    },
    domProps: {
      "value": (_vm.model.enableBuyMembershipByLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enableBuyMembershipByLocation", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("shouldFilterMembershipByLastOrByGym - da li treba korisnicima da filtiram pakete za kupovinu clanarina na osnovu prethodne clanarine ili na osnovu dodeljene teretane.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(63), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shouldFilterMembershipByLastOrByGym),
      expression: "model.shouldFilterMembershipByLastOrByGym"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "shouldFilterMembershipByLastOrByGym"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.shouldFilterMembershipByLastOrByGym) ? _vm._i(_vm.model.shouldFilterMembershipByLastOrByGym, null) > -1 : (_vm.model.shouldFilterMembershipByLastOrByGym)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.shouldFilterMembershipByLastOrByGym,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "shouldFilterMembershipByLastOrByGym", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "shouldFilterMembershipByLastOrByGym", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "shouldFilterMembershipByLastOrByGym", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("defaultMembershipsVisibleForAll - ukoliko korisnik nema ni jednu clanarinu prikazi mu ove default ako su dodate")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(64), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.defaultMembershipsVisibleForAll),
      expression: "model.defaultMembershipsVisibleForAll"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "defaultMembershipsVisibleForAll"
    },
    domProps: {
      "value": (_vm.model.defaultMembershipsVisibleForAll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "defaultMembershipsVisibleForAll", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("busyProgress - da li ukljucen progress za zauzetost teretane. ovaj broj govori koliko clanova pravi guzvu u teretani. Ako je 0, znaci da nije.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(65), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.busyProgress),
      expression: "model.busyProgress"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "busyProgress"
    },
    domProps: {
      "value": (_vm.model.busyProgress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "busyProgress", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("memberShipCategories - kategorije za clanarine ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(66), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.memberShipCategories),
      expression: "model.memberShipCategories"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "busyProgress"
    },
    domProps: {
      "value": (_vm.model.memberShipCategories)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "memberShipCategories", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("tabsOnHomePage")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(67), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tabsOnHomePage),
      expression: "model.tabsOnHomePage"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "tabsOnHomePage"
    },
    domProps: {
      "value": (_vm.model.tabsOnHomePage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tabsOnHomePage", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("usersCanReserveOnlyForCurrentWeek")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(68), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.usersCanReserveOnlyForCurrentWeek),
      expression: "model.usersCanReserveOnlyForCurrentWeek"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "usersCanReserveOnlyForCurrentWeek"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.usersCanReserveOnlyForCurrentWeek) ? _vm._i(_vm.model.usersCanReserveOnlyForCurrentWeek, null) > -1 : (_vm.model.usersCanReserveOnlyForCurrentWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.usersCanReserveOnlyForCurrentWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "usersCanReserveOnlyForCurrentWeek", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "usersCanReserveOnlyForCurrentWeek", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "usersCanReserveOnlyForCurrentWeek", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("timeWhenUserCanSeeSlotsForNextWeek - potrebno je staviti polje na sledeci nacin, recimo ako hocemo da stavimo da ne vide termine pre 10 i 15 -> 10015")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(69), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.timeWhenUserCanSeeSlotsForNextWeek),
      expression: "model.timeWhenUserCanSeeSlotsForNextWeek"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "timeWhenUserCanSeeSlotsForNextWeek"
    },
    domProps: {
      "value": (_vm.model.timeWhenUserCanSeeSlotsForNextWeek)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "timeWhenUserCanSeeSlotsForNextWeek", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("usersCanReserveTrainingWithScanQr "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showQrCode()
      }
    }
  }, [_vm._v("Prikazi QR kod")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(70), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.usersCanReserveTrainingWithScanQr),
      expression: "model.usersCanReserveTrainingWithScanQr"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "usersCanReserveTrainingWithScanQr"
    },
    domProps: {
      "value": (_vm.model.usersCanReserveTrainingWithScanQr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "usersCanReserveTrainingWithScanQr", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("appHeaderImage")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(71), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.appHeaderImage),
      expression: "model.appHeaderImage"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "appHeaderImage"
    },
    domProps: {
      "value": (_vm.model.appHeaderImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "appHeaderImage", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enablePayWithCreditCards")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(72), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enablePayWithCreditCards),
      expression: "model.enablePayWithCreditCards"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enablePayWithCreditCards"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enablePayWithCreditCards) ? _vm._i(_vm.model.enablePayWithCreditCards, null) > -1 : (_vm.model.enablePayWithCreditCards)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enablePayWithCreditCards,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enablePayWithCreditCards", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enablePayWithCreditCards", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enablePayWithCreditCards", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enablePayWithIpsQrCode")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(73), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enablePayWithIpsQrCode),
      expression: "model.enablePayWithIpsQrCode"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enablePayWithIpsQrCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enablePayWithIpsQrCode) ? _vm._i(_vm.model.enablePayWithIpsQrCode, null) > -1 : (_vm.model.enablePayWithIpsQrCode)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enablePayWithIpsQrCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enablePayWithIpsQrCode", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enablePayWithIpsQrCode", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enablePayWithIpsQrCode", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableExploreApp")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(74), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableExploreApp),
      expression: "model.enableExploreApp"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableExploreApp"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableExploreApp) ? _vm._i(_vm.model.enableExploreApp, null) > -1 : (_vm.model.enableExploreApp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableExploreApp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableExploreApp", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableExploreApp", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableExploreApp", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("appCustomColors")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(75), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.appCustomColors),
      expression: "model.appCustomColors"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "appHeaderImage"
    },
    domProps: {
      "value": (_vm.model.appCustomColors)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "appCustomColors", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("sugarWodUrl")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(76), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sugarWodUrl),
      expression: "model.sugarWodUrl"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "appHeaderImage"
    },
    domProps: {
      "value": (_vm.model.sugarWodUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "sugarWodUrl", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("appBottomBarItems")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(77), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.appBottomBarItems),
      expression: "model.appBottomBarItems"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "appHeaderImage"
    },
    domProps: {
      "value": (_vm.model.appBottomBarItems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "appBottomBarItems", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showCheckInBottomBar")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(78), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showCheckInBottomBar),
      expression: "model.showCheckInBottomBar"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "showCheckInBottomBar"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showCheckInBottomBar) ? _vm._i(_vm.model.showCheckInBottomBar, null) > -1 : (_vm.model.showCheckInBottomBar)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showCheckInBottomBar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showCheckInBottomBar", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showCheckInBottomBar", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showCheckInBottomBar", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("shouldApproveReservedTraining")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(79), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shouldApproveReservedTraining),
      expression: "model.shouldApproveReservedTraining"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "shouldApproveReservedTraining"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.shouldApproveReservedTraining) ? _vm._i(_vm.model.shouldApproveReservedTraining, null) > -1 : (_vm.model.shouldApproveReservedTraining)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.shouldApproveReservedTraining,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "shouldApproveReservedTraining", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "shouldApproveReservedTraining", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "shouldApproveReservedTraining", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("birthdayMessage")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(80), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.birthdayMessage),
      expression: "model.birthdayMessage"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "birthdayMessage"
    },
    domProps: {
      "value": (_vm.model.birthdayMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "birthdayMessage", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("additionalServiceTypes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(81), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.additionalServiceTypes),
      expression: "model.additionalServiceTypes"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "additionalServiceTypes"
    },
    domProps: {
      "value": (_vm.model.additionalServiceTypes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "additionalServiceTypes", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableEntryWithScanQrCodeOnEnterOfGym")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(82), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableEntryWithScanQrCodeOnEnterOfGym),
      expression: "model.enableEntryWithScanQrCodeOnEnterOfGym"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableEntryWithScanQrCodeOnEnterOfGym"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableEntryWithScanQrCodeOnEnterOfGym) ? _vm._i(_vm.model.enableEntryWithScanQrCodeOnEnterOfGym, null) > -1 : (_vm.model.enableEntryWithScanQrCodeOnEnterOfGym)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableEntryWithScanQrCodeOnEnterOfGym,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableEntryWithScanQrCodeOnEnterOfGym", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableEntryWithScanQrCodeOnEnterOfGym", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableEntryWithScanQrCodeOnEnterOfGym", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("shouldUseQrScannerAsEntrance")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(83), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shouldUseQrScannerAsEntrance),
      expression: "model.shouldUseQrScannerAsEntrance"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "shouldUseQrScannerAsEntrance"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.shouldUseQrScannerAsEntrance) ? _vm._i(_vm.model.shouldUseQrScannerAsEntrance, null) > -1 : (_vm.model.shouldUseQrScannerAsEntrance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.shouldUseQrScannerAsEntrance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "shouldUseQrScannerAsEntrance", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "shouldUseQrScannerAsEntrance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "shouldUseQrScannerAsEntrance", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("chooseLocationOnLogin")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(84), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.chooseLocationOnLogin),
      expression: "model.chooseLocationOnLogin"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "chooseLocationOnLogin"
    },
    domProps: {
      "value": (_vm.model.chooseLocationOnLogin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "chooseLocationOnLogin", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableShopAndOrder - da li korisnici mogu direktno da kupuju preko app i da admini vide ordere")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(85), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableShopAndOrder),
      expression: "model.enableShopAndOrder"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableShopAndOrder"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableShopAndOrder) ? _vm._i(_vm.model.enableShopAndOrder, null) > -1 : (_vm.model.enableShopAndOrder)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableShopAndOrder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableShopAndOrder", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableShopAndOrder", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableShopAndOrder", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enablePersonalProgram - da li je ukljucen personalni program")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(86), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enablePersonalProgram),
      expression: "model.enablePersonalProgram"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enablePersonalProgram"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enablePersonalProgram) ? _vm._i(_vm.model.enablePersonalProgram, null) > -1 : (_vm.model.enablePersonalProgram)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enablePersonalProgram,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enablePersonalProgram", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enablePersonalProgram", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enablePersonalProgram", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("personalProgramUrl")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(87), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.personalProgramUrl),
      expression: "model.personalProgramUrl"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "personalProgramUrl"
    },
    domProps: {
      "value": (_vm.model.personalProgramUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "personalProgramUrl", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("trainingTypeVisibleDays")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(88), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingTypeVisibleDays),
      expression: "model.trainingTypeVisibleDays"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "trainingTypeVisibleDays"
    },
    domProps: {
      "value": (_vm.model.trainingTypeVisibleDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "trainingTypeVisibleDays", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("personalBottomBarItems")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(89), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.personalBottomBarItems),
      expression: "model.personalBottomBarItems"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "personalBottomBarItems"
    },
    domProps: {
      "value": (_vm.model.personalBottomBarItems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "personalBottomBarItems", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("canUserSeeTrainingReservation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(90), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canUserSeeTrainingReservation),
      expression: "model.canUserSeeTrainingReservation"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "discount"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.canUserSeeTrainingReservation) ? _vm._i(_vm.model.canUserSeeTrainingReservation, null) > -1 : (_vm.model.canUserSeeTrainingReservation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.canUserSeeTrainingReservation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "canUserSeeTrainingReservation", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "canUserSeeTrainingReservation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "canUserSeeTrainingReservation", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("personalShouldShowFirst")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(91), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.personalShouldShowFirst),
      expression: "model.personalShouldShowFirst"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "discount"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.personalShouldShowFirst) ? _vm._i(_vm.model.personalShouldShowFirst, null) > -1 : (_vm.model.personalShouldShowFirst)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.personalShouldShowFirst,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "personalShouldShowFirst", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "personalShouldShowFirst", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "personalShouldShowFirst", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("urlToAccept")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(92), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.urlToAccept),
      expression: "model.urlToAccept"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "personalBottomBarItems"
    },
    domProps: {
      "value": (_vm.model.urlToAccept)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "urlToAccept", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("hiddenActionsWhenExpiredMembership")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(93), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.hiddenActionsWhenExpiredMembership),
      expression: "model.hiddenActionsWhenExpiredMembership"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "personalBottomBarItems"
    },
    domProps: {
      "value": (_vm.model.hiddenActionsWhenExpiredMembership)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "hiddenActionsWhenExpiredMembership", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("showMembershipsAsTab")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(94), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.showMembershipsAsTab),
      expression: "model.showMembershipsAsTab"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "showMembershipsAsTab"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.showMembershipsAsTab) ? _vm._i(_vm.model.showMembershipsAsTab, null) > -1 : (_vm.model.showMembershipsAsTab)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.showMembershipsAsTab,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "showMembershipsAsTab", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "showMembershipsAsTab", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "showMembershipsAsTab", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("recensionUrl")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(95), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.recensionUrl),
      expression: "model.recensionUrl"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "recensionUrl"
    },
    domProps: {
      "value": (_vm.model.recensionUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "recensionUrl", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("dismissTypesForFilterByLocation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(96), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.dismissTypesForFilterByLocation),
      expression: "model.dismissTypesForFilterByLocation"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "dismissTypesForFilterByLocation"
    },
    domProps: {
      "value": (_vm.model.dismissTypesForFilterByLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "dismissTypesForFilterByLocation", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useCredits")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(97), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useCredits),
      expression: "model.useCredits"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useCredits"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useCredits) ? _vm._i(_vm.model.useCredits, null) > -1 : (_vm.model.useCredits)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useCredits,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useCredits", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useCredits", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useCredits", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useCreditsToBuyForShop")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(98), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useCreditsToBuyForShop),
      expression: "model.useCreditsToBuyForShop"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useCreditsToBuyForShop"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useCreditsToBuyForShop) ? _vm._i(_vm.model.useCreditsToBuyForShop, null) > -1 : (_vm.model.useCreditsToBuyForShop)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useCreditsToBuyForShop,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useCreditsToBuyForShop", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useCreditsToBuyForShop", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useCreditsToBuyForShop", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("userCanSeeAllSchedule")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(99), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userCanSeeAllSchedule),
      expression: "model.userCanSeeAllSchedule"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "userCanSeeAllSchedule"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.userCanSeeAllSchedule) ? _vm._i(_vm.model.userCanSeeAllSchedule, null) > -1 : (_vm.model.userCanSeeAllSchedule)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.userCanSeeAllSchedule,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "userCanSeeAllSchedule", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "userCanSeeAllSchedule", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "userCanSeeAllSchedule", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("userDoNotHavePermissionToReserve")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(100), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userDoNotHavePermissionToReserve),
      expression: "model.userDoNotHavePermissionToReserve"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "userDoNotHavePermissionToReserve"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.userDoNotHavePermissionToReserve) ? _vm._i(_vm.model.userDoNotHavePermissionToReserve, null) > -1 : (_vm.model.userDoNotHavePermissionToReserve)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.userDoNotHavePermissionToReserve,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "userDoNotHavePermissionToReserve", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "userDoNotHavePermissionToReserve", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "userDoNotHavePermissionToReserve", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("sendNotificationToTrainerWhenAddedNewUserToHim")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(101), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sendNotificationToTrainerWhenAddedNewUserToHim),
      expression: "model.sendNotificationToTrainerWhenAddedNewUserToHim"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "userDoNotHavePermissionToReserve"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.sendNotificationToTrainerWhenAddedNewUserToHim) ? _vm._i(_vm.model.sendNotificationToTrainerWhenAddedNewUserToHim, null) > -1 : (_vm.model.sendNotificationToTrainerWhenAddedNewUserToHim)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.sendNotificationToTrainerWhenAddedNewUserToHim,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "sendNotificationToTrainerWhenAddedNewUserToHim", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "sendNotificationToTrainerWhenAddedNewUserToHim", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "sendNotificationToTrainerWhenAddedNewUserToHim", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useTranslations")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(102), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useTranslations),
      expression: "model.useTranslations"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "userDoNotHavePermissionToReserve"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useTranslations) ? _vm._i(_vm.model.useTranslations, null) > -1 : (_vm.model.useTranslations)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useTranslations,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useTranslations", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useTranslations", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useTranslations", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("userCanSeeOnlyOwnSlotAndFreeSlot")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(103), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userCanSeeOnlyOwnSlotAndFreeSlot),
      expression: "model.userCanSeeOnlyOwnSlotAndFreeSlot"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "userCanSeeOnlyOwnSlotAndFreeSlot"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.userCanSeeOnlyOwnSlotAndFreeSlot) ? _vm._i(_vm.model.userCanSeeOnlyOwnSlotAndFreeSlot, null) > -1 : (_vm.model.userCanSeeOnlyOwnSlotAndFreeSlot)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.userCanSeeOnlyOwnSlotAndFreeSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "userCanSeeOnlyOwnSlotAndFreeSlot", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "userCanSeeOnlyOwnSlotAndFreeSlot", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "userCanSeeOnlyOwnSlotAndFreeSlot", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("frontUrl")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(104), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.frontUrl),
      expression: "model.frontUrl"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "frontUrl",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.frontUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "frontUrl", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableMyDictionary")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(105), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableMyDictionary),
      expression: "model.enableMyDictionary"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableMyDictionary"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableMyDictionary) ? _vm._i(_vm.model.enableMyDictionary, null) > -1 : (_vm.model.enableMyDictionary)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableMyDictionary,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableMyDictionary", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableMyDictionary", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableMyDictionary", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("adminCanReserveTrainingAlways")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(106), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.adminCanReserveTrainingAlways),
      expression: "model.adminCanReserveTrainingAlways"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableMyDictionary"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.adminCanReserveTrainingAlways) ? _vm._i(_vm.model.adminCanReserveTrainingAlways, null) > -1 : (_vm.model.adminCanReserveTrainingAlways)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.adminCanReserveTrainingAlways,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "adminCanReserveTrainingAlways", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "adminCanReserveTrainingAlways", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "adminCanReserveTrainingAlways", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useEntranceAsBusyInGym")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(107), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useEntranceAsBusyInGym),
      expression: "model.useEntranceAsBusyInGym"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useEntranceAsBusyInGym"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useEntranceAsBusyInGym) ? _vm._i(_vm.model.useEntranceAsBusyInGym, null) > -1 : (_vm.model.useEntranceAsBusyInGym)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useEntranceAsBusyInGym,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useEntranceAsBusyInGym", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useEntranceAsBusyInGym", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useEntranceAsBusyInGym", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("workingHoursForEntrance")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(108), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.workingHoursForEntrance),
      expression: "model.workingHoursForEntrance"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "1->00:00-02:00;2->...",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.workingHoursForEntrance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "workingHoursForEntrance", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableOrderReservation")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(109), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableOrderReservation),
      expression: "model.enableOrderReservation"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableOrderReservation"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableOrderReservation) ? _vm._i(_vm.model.enableOrderReservation, null) > -1 : (_vm.model.enableOrderReservation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableOrderReservation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableOrderReservation", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableOrderReservation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableOrderReservation", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableSeeOtherMemberOnSlot (if null it's like true)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(110), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableSeeOtherMemberOnSlot),
      expression: "model.enableSeeOtherMemberOnSlot"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableSeeOtherMemberOnSlot"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableSeeOtherMemberOnSlot) ? _vm._i(_vm.model.enableSeeOtherMemberOnSlot, null) > -1 : (_vm.model.enableSeeOtherMemberOnSlot)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableSeeOtherMemberOnSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableSeeOtherMemberOnSlot", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableSeeOtherMemberOnSlot", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableSeeOtherMemberOnSlot", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("alwaysAllowTrainingTypeOnQrEntrance")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(111), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.alwaysAllowTrainingTypeOnQrEntrance),
      expression: "model.alwaysAllowTrainingTypeOnQrEntrance"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "alwaysAllowTrainingTypeOnQrEntrance",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.alwaysAllowTrainingTypeOnQrEntrance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "alwaysAllowTrainingTypeOnQrEntrance", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useLocationFromComputerOnPultWhenEntrance")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(112), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useLocationFromComputerOnPultWhenEntrance),
      expression: "model.useLocationFromComputerOnPultWhenEntrance"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useLocationFromComputerOnPultWhenEntrance"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useLocationFromComputerOnPultWhenEntrance) ? _vm._i(_vm.model.useLocationFromComputerOnPultWhenEntrance, null) > -1 : (_vm.model.useLocationFromComputerOnPultWhenEntrance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useLocationFromComputerOnPultWhenEntrance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useLocationFromComputerOnPultWhenEntrance", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useLocationFromComputerOnPultWhenEntrance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useLocationFromComputerOnPultWhenEntrance", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("registrationRequiredFields")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(113), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.registrationRequiredFields),
      expression: "model.registrationRequiredFields"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "registrationRequiredFields",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.registrationRequiredFields)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "registrationRequiredFields", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("registrationHiddenFields")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(114), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.registrationHiddenFields),
      expression: "model.registrationHiddenFields"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "registrationHiddenFields",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.registrationHiddenFields)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "registrationHiddenFields", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("versionInReviewIOS")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(115), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.versionInReviewIOS),
      expression: "model.versionInReviewIOS"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "versionInReviewIOS",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.versionInReviewIOS)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "versionInReviewIOS", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("versionInReviewAndroid")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(116), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.versionInReviewAndroid),
      expression: "model.versionInReviewAndroid"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "versionInReviewAndroid",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.versionInReviewAndroid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "versionInReviewAndroid", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("versionInReviewHuawei")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(117), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.versionInReviewHuawei),
      expression: "model.versionInReviewHuawei"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "versionInReviewHuawei",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.versionInReviewHuawei)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "versionInReviewHuawei", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("addNumberTrainingsWithNewPaymentWithCurrentState")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(118), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.addNumberTrainingsWithNewPaymentWithCurrentState),
      expression: "model.addNumberTrainingsWithNewPaymentWithCurrentState"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "addNumberTrainingsWithNewPaymentWithCurrentState"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.addNumberTrainingsWithNewPaymentWithCurrentState) ? _vm._i(_vm.model.addNumberTrainingsWithNewPaymentWithCurrentState, null) > -1 : (_vm.model.addNumberTrainingsWithNewPaymentWithCurrentState)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.addNumberTrainingsWithNewPaymentWithCurrentState,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "addNumberTrainingsWithNewPaymentWithCurrentState", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "addNumberTrainingsWithNewPaymentWithCurrentState", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "addNumberTrainingsWithNewPaymentWithCurrentState", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("shouldUseQrScannerAsTimedSlot")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(119), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shouldUseQrScannerAsTimedSlot),
      expression: "model.shouldUseQrScannerAsTimedSlot"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "shouldUseQrScannerAsTimedSlot"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.shouldUseQrScannerAsTimedSlot) ? _vm._i(_vm.model.shouldUseQrScannerAsTimedSlot, null) > -1 : (_vm.model.shouldUseQrScannerAsTimedSlot)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.shouldUseQrScannerAsTimedSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "shouldUseQrScannerAsTimedSlot", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "shouldUseQrScannerAsTimedSlot", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "shouldUseQrScannerAsTimedSlot", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useFocusForScannerTimedSlot")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(120), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useFocusForScannerTimedSlot),
      expression: "model.useFocusForScannerTimedSlot"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useFocusForScannerTimedSlot"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useFocusForScannerTimedSlot) ? _vm._i(_vm.model.useFocusForScannerTimedSlot, null) > -1 : (_vm.model.useFocusForScannerTimedSlot)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useFocusForScannerTimedSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useFocusForScannerTimedSlot", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useFocusForScannerTimedSlot", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useFocusForScannerTimedSlot", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("userCanSeeOnlySlotsFromMyTrainer")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(121), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userCanSeeOnlySlotsFromMyTrainer),
      expression: "model.userCanSeeOnlySlotsFromMyTrainer"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "userCanSeeOnlySlotsFromMyTrainer"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.userCanSeeOnlySlotsFromMyTrainer) ? _vm._i(_vm.model.userCanSeeOnlySlotsFromMyTrainer, null) > -1 : (_vm.model.userCanSeeOnlySlotsFromMyTrainer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.userCanSeeOnlySlotsFromMyTrainer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "userCanSeeOnlySlotsFromMyTrainer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "userCanSeeOnlySlotsFromMyTrainer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "userCanSeeOnlySlotsFromMyTrainer", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("trainerCanSeeOnlyOwnSlots")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(122), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainerCanSeeOnlyOwnSlots),
      expression: "model.trainerCanSeeOnlyOwnSlots"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "trainerCanSeeOnlyOwnSlots"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.trainerCanSeeOnlyOwnSlots) ? _vm._i(_vm.model.trainerCanSeeOnlyOwnSlots, null) > -1 : (_vm.model.trainerCanSeeOnlyOwnSlots)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.trainerCanSeeOnlyOwnSlots,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "trainerCanSeeOnlyOwnSlots", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "trainerCanSeeOnlyOwnSlots", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "trainerCanSeeOnlyOwnSlots", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableSubscriptionModel")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(123), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableSubscriptionModel),
      expression: "model.enableSubscriptionModel"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableSubscriptionModel"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableSubscriptionModel) ? _vm._i(_vm.model.enableSubscriptionModel, null) > -1 : (_vm.model.enableSubscriptionModel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableSubscriptionModel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableSubscriptionModel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableSubscriptionModel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableSubscriptionModel", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enablePutNotificationForMembership")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(124), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enablePutNotificationForMembership),
      expression: "model.enablePutNotificationForMembership"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enablePutNotificationForMembership"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enablePutNotificationForMembership) ? _vm._i(_vm.model.enablePutNotificationForMembership, null) > -1 : (_vm.model.enablePutNotificationForMembership)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enablePutNotificationForMembership,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enablePutNotificationForMembership", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enablePutNotificationForMembership", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enablePutNotificationForMembership", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("resetNumberOfTrainingsIfExpireMembership")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(125), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.resetNumberOfTrainingsIfExpireMembership),
      expression: "model.resetNumberOfTrainingsIfExpireMembership"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "resetNumberOfTrainingsIfExpireMembership"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.resetNumberOfTrainingsIfExpireMembership) ? _vm._i(_vm.model.resetNumberOfTrainingsIfExpireMembership, null) > -1 : (_vm.model.resetNumberOfTrainingsIfExpireMembership)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.resetNumberOfTrainingsIfExpireMembership,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "resetNumberOfTrainingsIfExpireMembership", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "resetNumberOfTrainingsIfExpireMembership", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "resetNumberOfTrainingsIfExpireMembership", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableMakingBills")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(126), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableMakingBills),
      expression: "model.enableMakingBills"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableMakingBills"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableMakingBills) ? _vm._i(_vm.model.enableMakingBills, null) > -1 : (_vm.model.enableMakingBills)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableMakingBills,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableMakingBills", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableMakingBills", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableMakingBills", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("enableSkyPosIntegration")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(127), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableSkyPosIntegration),
      expression: "model.enableSkyPosIntegration"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "enableSkyPosIntegration"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableSkyPosIntegration) ? _vm._i(_vm.model.enableSkyPosIntegration, null) > -1 : (_vm.model.enableSkyPosIntegration)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableSkyPosIntegration,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableSkyPosIntegration", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableSkyPosIntegration", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableSkyPosIntegration", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("sendRegistrationEmailWhenAdminCreateUser")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(128), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sendRegistrationEmailWhenAdminCreateUser),
      expression: "model.sendRegistrationEmailWhenAdminCreateUser"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "sendRegistrationEmailWhenAdminCreateUser"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.sendRegistrationEmailWhenAdminCreateUser) ? _vm._i(_vm.model.sendRegistrationEmailWhenAdminCreateUser, null) > -1 : (_vm.model.sendRegistrationEmailWhenAdminCreateUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.sendRegistrationEmailWhenAdminCreateUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "sendRegistrationEmailWhenAdminCreateUser", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "sendRegistrationEmailWhenAdminCreateUser", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "sendRegistrationEmailWhenAdminCreateUser", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("hideMembershipCard")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(129), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.hideMembershipCard),
      expression: "model.hideMembershipCard"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "hideMembershipCard"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.hideMembershipCard) ? _vm._i(_vm.model.hideMembershipCard, null) > -1 : (_vm.model.hideMembershipCard)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.hideMembershipCard,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "hideMembershipCard", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "hideMembershipCard", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "hideMembershipCard", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("maxCapacityActiveUsers - koliko aktivnih usera moze max (ostali na listu cekanja) ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(130), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxCapacityActiveUsers),
      expression: "model.maxCapacityActiveUsers"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "maxCapacityActiveUsers"
    },
    domProps: {
      "value": (_vm.model.maxCapacityActiveUsers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxCapacityActiveUsers", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("validityCreditInDays ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(131), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.validityCreditInDays),
      expression: "model.validityCreditInDays"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "validityCreditInDays"
    },
    domProps: {
      "value": (_vm.model.validityCreditInDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "validityCreditInDays", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("mandatoryReservedTrainingTypesForEntrance")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(132), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.mandatoryReservedTrainingTypesForEntrance),
      expression: "model.mandatoryReservedTrainingTypesForEntrance"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "mandatoryReservedTrainingTypesForEntrance",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.mandatoryReservedTrainingTypesForEntrance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "mandatoryReservedTrainingTypesForEntrance", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("firstMembershipTypesForRegistrations")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(133), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.firstMembershipTypesForRegistrations),
      expression: "model.firstMembershipTypesForRegistrations"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "firstMembershipTypesForRegistrations",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.model.firstMembershipTypesForRegistrations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "firstMembershipTypesForRegistrations", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("useSaldoInsteadCreditOnMobileApp")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(134), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useSaldoInsteadCreditOnMobileApp),
      expression: "model.useSaldoInsteadCreditOnMobileApp"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "name": "useSaldoInsteadCreditOnMobileApp"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.useSaldoInsteadCreditOnMobileApp) ? _vm._i(_vm.model.useSaldoInsteadCreditOnMobileApp, null) > -1 : (_vm.model.useSaldoInsteadCreditOnMobileApp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.useSaldoInsteadCreditOnMobileApp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "useSaldoInsteadCreditOnMobileApp", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "useSaldoInsteadCreditOnMobileApp", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "useSaldoInsteadCreditOnMobileApp", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("maxTrainingsPerDayForSameSlot ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(135), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxTrainingsPerDayForSameSlot),
      expression: "model.maxTrainingsPerDayForSameSlot"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "maxTrainingsPerDayForSameSlot"
    },
    domProps: {
      "value": (_vm.model.maxTrainingsPerDayForSameSlot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxTrainingsPerDayForSameSlot", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.update
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" Sačuvaj\n                  ")])])])]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('show-qr-code-dialog', {
    attrs: {
      "show": _vm.showQrCodeItem != null,
      "item": _vm.showQrCodeItem
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7de6ff39!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/Configuration.vue
// module id = 798
// module chunks = 0